import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoChargingSessionListStatusHeaderProps
  extends HeaderContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['status']
  > {}

export const EmspBoChargingSessionListStatusHeader =
  (): // props: EmspBoChargingSessionListStatusHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-charging-session.status');
  };
